const { MinimogThemeStyles, MinimogThemeScripts } = window;

class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
    this.isOpen = false;
    this.isLoading = false;

    // Event delegation for quick view button
    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        if (this.isLoading) return;
        this.target = target;
        this.toggleLoading(true);
        const productHandle = target.dataset.productHandle;
        if (productHandle) this.loadProductQuickView(productHandle);
      },
    });

    // Subscribe to cart update events
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) this.modal.close();
    });
    window.MinimogEvents.subscribe('ON_MODAL_CLOSED', (modal) => {
      this.close();
    });
  }

  // Load product quick view HTML
  loadProductQuickView(productHandle) {
    if (this.isOpen) {
      this.modal && this.modal.close(); // Close any existing modal before loading a new one
    }
    this.isLoading = true;

    // Construct the URL properly with validation
    let productUrl;
    try {
      // Get the base URL - use the root route if it's a full URL, otherwise build from origin
      let baseUrl = window.MinimogSettings?.routes?.root || '';
      
      // If root is just a path (starts with / but not //), combine with origin
      if (baseUrl.startsWith('/') && !baseUrl.startsWith('//')) {
        baseUrl = window.location.origin + baseUrl;
      } else if (!baseUrl.startsWith('http')) {
        // If no valid base URL, use current origin
        baseUrl = window.location.origin;
      }
      
      // Ensure baseUrl doesn't end with a slash
      const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
      productUrl = `${cleanBaseUrl}/products/${productHandle}`;
      
      console.log('Fetching product URL:', productUrl); // Debug log
    } catch (error) {
      console.error('Error constructing product URL:', error);
      this.toggleLoading(false);
      this.isLoading = false;
      return;
    }

    // Ensure productUrl is a string, not a URL object
    fetchSection("product-quickview", { url: String(productUrl) })
      .then((html) => {
        this.modalContent = html.querySelector("#MainProduct-quick-view__content");
        const productInfo = html.querySelector("product-info");
        const colorScheme = productInfo?.dataset?.colorScheme || '';
        this.modal.appendChild(this.modalContent);
        this.modal.setWidth("960px");

        const sectionWrapper = this.modal.modal.querySelector('#MainProduct-quick-view__content');

        sectionWrapper.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        this.modal.open();
        this.modal.setSizes(`m-gradient ${colorScheme}`);

        this.toggleLoading(false);
        this.isOpen = true;
        this.isLoading = false; // Reset loading state
      })
      .then(() => {
        document.dispatchEvent(
          new CustomEvent('tcustomizer-custom-show-quick-view', {
            detail: { productHandle: this.target.dataset.productHandle }
          })
        );

        document.dispatchEvent(
          new CustomEvent("quick-view:loaded", {
            detail: { productUrl: this.target.dataset.productHandle }
          })
        );
      })
      .catch((error) => {
        console.error("Error loading product quick view:", error);
        this.toggleLoading(false);
        this.isLoading = false;
      });
  }

  // Close the quick view modal
  close() {
    this.isOpen = false;
  }

  // Toggle loading spinner on the target element
  toggleLoading(isLoading) {
    if (this.isLoading && this.target) {
      if (isLoading) {
        this.target.classList.add("m-spinner-loading");
      } else {
        this.target.classList.remove("m-spinner-loading");
      }
    }
  }
}

// Initialize the QuickView instance
MinimogTheme.ProductQuickView = new QuickView();